var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hints-documentation"},[_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.tagInfo),function(tag){return _c('li',{key:tag.tag,staticClass:"mb-2"},[_c('span',{staticClass:"tag-name font-weight-bold"},[_vm._v("<"+_vm._s(tag.tag)+">")]),_vm._v("   "),_c('span',{staticClass:"tag-description"},[_vm._v(_vm._s(tag.descr))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }